var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"c-login-header"},[_c('c-qual-pro')],1)}
var staticRenderFns = []

export { render, staticRenderFns }